import Faculties from "./Faculties/Faculties";
import Grants from "./Grants/Grants";
import Publications from "./Publications/Publications";
import SubUnit from "./SubUnit/SubUnit";
import Summary from "./Summary/Summary";
export const contentList = (entity_credential) => [
  {
    label: "Summary",
    path: `/admin/units/${entity_credential}/summary`,
    component: Summary,
  },
  {
    label: "Faculty members",
    path: `/admin/units/${entity_credential}/faculty-members`,
    component: Faculties,
  },
  {
    label: "Sub units",
    path: `/admin/units/${entity_credential}/sub-unit`,
    component: SubUnit,
  },
  {
    label: "Publications",
    path: `/admin/units/${entity_credential}/publications`,
    component: Publications,
  },
  {
    label: "Grants",
    path: `/admin/units/${entity_credential}/grants`,
    component: Grants,
  },
];
